module.exports = __webpack_public_path__ + "static/media/vs.9bf191e9.png";